import { PaymentApiErrorCode } from '@mfw/common';

import { BadRequestError } from '../../api/http';

export const isMembershipTermsRequiredError = (error: unknown) =>
  error instanceof BadRequestError &&
  error.code === PaymentApiErrorCode.MEMBERSHIP_TOU_REQUIRED;
